const customization = [
  {
    path: '/customization/user-info',
    name: 'customization-user-info',
    component: resolve => {
      require(['@/views/customization/user-info'], resolve)
    },
    meta: {
      title: '个人信息',
      bg: '#F4F6F9'
    }
  },
  {
    path: '/customization/check-choice',
    name: 'customization-check-choice',
    component: resolve => {
      require(['@/views/customization/check-choice'], resolve)
    },
    meta: {
      title: '选择机构',
      bg: '#F4F6F9'
    }
  },
  {
    path: '/customization/check-subject',
    name: 'customization-check-subject',
    component: resolve => {
      require(['@/views/customization/check-subject'], resolve)
    },
    meta: {
      title: '选择学科',
      bg: '#F4F6F9'
    }
  },
  {
    path: '/customization/check-success',
    name: 'customization-check-success',
    component: resolve => {
      require(['@/views/customization/check-success'], resolve)
    },
    meta: {
      title: '修改成功',
      bg: '#F4F6F9'
    }
  },
  {
    path: '/customization/history',
    name: 'customization-history',
    component: resolve => {
      require(['@/views/customization/history'], resolve)
    },
    meta: {
      title: '观看历史',
      bg: '#F4F6F9'
    }
  },
  {
    path: '/customization/history-detail/:id',
    name: 'customization-history-detail',
    component: resolve => {
      require(['@/views/customization/history-detail'], resolve)
    },
    meta: {
      title: '观看历史',
      bg: '#F4F6F9'
    }
  },
  {
    path: '/customization/report',
    name: 'customization-report',
    component: resolve => {
      require(['@/views/customization/report'], resolve)
    },
    meta: {
      title: '活动报告',
      bg: '#F4F6F9'
    }
  },
  {
    path: '/jjzm',
    component: resolve => {
      require(['@/views/customization/jjzm'], resolve)
    }
  }
]

export default customization
